import { TCardEntry } from 'components-ui'
import type { FlexBookingConfClientDto } from 'service-api/src/types/api'

export const getArrivalDepartureCards = (flexBookingConfs: FlexBookingConfClientDto[] = []): TCardEntry[][] => {
  const cards = flexBookingConfs
    .slice()
    .sort((a, b) => (a.order || 0) - (b.order || 0))
    .filter(
      (conf) =>
        (conf.step as string) === 'ARRIVAL_DEPARTURE' &&
        (Boolean(conf.content?.trim()) || Boolean(conf.displayName?.trim()))
    )
    .map<TCardEntry>((conf) => ({
      displayName: conf.displayName,
      content: conf.content,
      description: conf.description,
      type: conf.type || undefined,
    }))

  return cards.length ? [cards] : []
}
